module.exports = __webpack_public_path__ + "svg/new-invoice-small.8230a7c92c5c89abb120856aa34a9cff.svg";